"use strict";
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
function formatMoney(cents) {
  if (typeof cents === "string") cents = cents.replace(/[^0-9]/g, "");
  const value = parseInt(cents, 10) / 100;
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(value);
}
(function initHeader() {
  const header = $(".site-header");
  if (!header) return;
  const isHome = document.body.classList.contains("template-index");
  function updateHeader() {
    const scrolled = window.scrollY > 50;
    if (isHome) {
      header.classList.toggle("site-header--transparent", !scrolled);
      header.classList.toggle("site-header--solid", scrolled);
    } else {
      header.classList.remove("site-header--transparent");
      header.classList.add("site-header--solid");
    }
  }
  if (isHome) {
    header.classList.add("site-header--transparent");
  } else {
    header.classList.add("site-header--solid");
  }
  window.addEventListener("scroll", updateHeader, { passive: true });
  updateHeader();
})();
(function initMobileNav() {
  const toggle = $(".mobile-menu-toggle");
  const nav = $(".mobile-nav");
  const close = $(".mobile-nav__close");
  const overlay = document.getElementById("overlay");
  if (!toggle || !nav) return;
  const openNav = () => {
    nav.classList.add("is-open");
    overlay == null ? void 0 : overlay.classList.add("is-visible");
    document.body.style.overflow = "hidden";
    toggle.setAttribute("aria-expanded", "true");
  };
  const closeNav = () => {
    nav.classList.remove("is-open");
    overlay == null ? void 0 : overlay.classList.remove("is-visible");
    document.body.style.overflow = "";
    toggle.setAttribute("aria-expanded", "false");
  };
  toggle.addEventListener("click", openNav);
  close == null ? void 0 : close.addEventListener("click", closeNav);
  overlay == null ? void 0 : overlay.addEventListener("click", closeNav);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeNav();
  });
})();
const Cart = {
  _data: { items: [], item_count: 0, total_price: 0 },
  async fetch() {
    const res = await fetch("/cart.js");
    this._data = await res.json();
    return this._data;
  },
  async addItem(id, quantity = 1, properties = {}) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity, properties })
    });
    if (!res.ok) throw new Error("Could not add item to cart");
    await this.fetch();
    return this._data;
  },
  async updateItem(id, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity })
    });
    if (!res.ok) throw new Error("Could not update cart");
    await this.fetch();
    return this._data;
  },
  async removeItem(id) {
    return this.updateItem(id, 0);
  }
};
(function initCartDrawer() {
  const drawer = $(".cart-drawer");
  const overlay = document.getElementById("overlay");
  const openBtns = $$("[data-cart-open]");
  const closeBtn = $(".cart-drawer__close");
  const countEl = $(".cart-count");
  if (!drawer) return;
  const openDrawer = () => {
    drawer.classList.add("is-open");
    overlay == null ? void 0 : overlay.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  };
  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    overlay == null ? void 0 : overlay.classList.remove("is-visible");
    document.body.style.overflow = "";
  };
  openBtns.forEach((btn) => btn.addEventListener("click", (e) => {
    e.preventDefault();
    openDrawer();
  }));
  closeBtn == null ? void 0 : closeBtn.addEventListener("click", closeDrawer);
  overlay == null ? void 0 : overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });
  function updateCartCount(count) {
    if (!countEl) return;
    countEl.textContent = String(count);
    countEl.classList.toggle("is-hidden", count === 0);
  }
  function renderCartItems(cart) {
    const body = $(".cart-drawer__body");
    const footer = $(".cart-drawer__footer");
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p class="cart-drawer__empty-title">Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-ghost" style="color:var(--color-primary);border-color:var(--color-primary);">
            Continue Shopping
          </a>
        </div>`;
      if (footer) footer.style.display = "none";
      return;
    }
    if (footer) footer.style.display = "";
    const subtotalEl = footer == null ? void 0 : footer.querySelector(".cart-subtotal__price");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    body.innerHTML = `<div class="cart-items">${cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${item.image}" alt="${item.product_title}" width="80" height="80">
        <div class="cart-item__info">
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-item__variant">${item.variant_title}</p>` : ""}
          <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
          <button class="cart-item__remove label-caps" data-remove="${item.key}">Remove</button>
        </div>
      </div>`).join("")}
    </div>`;
    $$("[data-remove]", body).forEach((btn) => {
      btn.addEventListener("click", async () => {
        const key = btn.dataset.remove;
        const cart2 = await Cart.removeItem(key);
        updateCartCount(cart2.item_count);
        renderCartItems(cart2);
      });
    });
  }
  Cart.fetch().then((cart) => {
    updateCartCount(cart.item_count);
    renderCartItems(cart);
  });
  document.addEventListener("cart:item-added", async () => {
    const cart = await Cart.fetch();
    updateCartCount(cart.item_count);
    renderCartItems(cart);
    openDrawer();
  });
})();
(function initProductForms() {
  $$(".product-form").forEach((form) => {
    const addBtn = form.querySelector(".add-to-cart-btn");
    const qtyInput = form.querySelector(".quantity-selector__input");
    const qtyMinus = form.querySelector("[data-qty-minus]");
    const qtyPlus = form.querySelector("[data-qty-plus]");
    qtyMinus == null ? void 0 : qtyMinus.addEventListener("click", () => {
      const val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = String(val - 1);
    });
    qtyPlus == null ? void 0 : qtyPlus.addEventListener("click", () => {
      qtyInput.value = String(parseInt(qtyInput.value, 10) + 1);
    });
    form.addEventListener("submit", async (e) => {
      var _a;
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      const id = (_a = form.querySelector('[name="id"]')) == null ? void 0 : _a.value;
      const qty = parseInt((qtyInput == null ? void 0 : qtyInput.value) || "1", 10);
      if (!id) return;
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="loading-spinner"></span>';
      try {
        await Cart.addItem(id, qty);
        document.dispatchEvent(new Event("cart:item-added"));
        addBtn.textContent = "Added!";
        setTimeout(() => {
          addBtn.disabled = false;
          addBtn.textContent = "Add to Cart";
        }, 2e3);
      } catch (e2) {
        addBtn.disabled = false;
        addBtn.textContent = "Add to Cart";
      }
    });
  });
})();
(function initVariantSelection() {
  const page = $(".product-page");
  if (!page) return;
  const jsonEl = page.querySelector("[data-product-variants]");
  const hiddenInput = page.querySelector('.product-form [name="id"]');
  const addBtn = page.querySelector(".add-to-cart-btn");
  const btns = $$(".variant-btn", page);
  if (!jsonEl || !hiddenInput || !btns.length) return;
  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent || "[]");
  } catch (e) {
    return;
  }
  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const pos = btn.dataset.optionPosition;
      $$(`.variant-btn[data-option-position="${pos}"]`, page).forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      const selected = {};
      $$(".variant-btn.is-active", page).forEach((b) => {
        if (b.dataset.optionPosition && b.dataset.value !== void 0) {
          selected[b.dataset.optionPosition] = b.dataset.value;
        }
      });
      const match = variants.find(
        (v) => (!selected["1"] || v.option1 === selected["1"]) && (!selected["2"] || v.option2 === selected["2"]) && (!selected["3"] || v.option3 === selected["3"])
      );
      if (match) {
        hiddenInput.value = String(match.id);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? "Add to Cart" : "Sold Out";
        }
      }
    });
  });
})();
(function initProductGallery() {
  const mainImg = $(".product-gallery__main img");
  if (!mainImg) return;
  $$(".product-gallery__thumb").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      var _a;
      const src = (_a = thumb.querySelector("img")) == null ? void 0 : _a.src;
      if (src) mainImg.src = src;
      $$(".product-gallery__thumb").forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
    });
  });
})();
(function initProductTabs() {
  $$(".product-tab").forEach((tab) => {
    const btn = tab.querySelector(".product-tab__btn");
    btn == null ? void 0 : btn.addEventListener("click", () => {
      const isOpen = tab.classList.contains("is-open");
      $$(".product-tab").forEach((t) => t.classList.remove("is-open"));
      if (!isOpen) tab.classList.add("is-open");
    });
  });
})();
(function initCollectionFilters() {
  const btns = $$(".filter-btn");
  const cards = $$("[data-card-wrap]");
  if (!btns.length || !cards.length) return;
  const handleize = (s) => s.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      btns.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      const tag = btn.dataset.tag;
      cards.forEach((card) => {
        const tags = (card.dataset.tags || "").split(",").map(handleize);
        card.style.display = tag === "all" || tags.includes(tag) ? "" : "none";
      });
    });
  });
})();
(function initIngredients() {
  const btns = $$(".ingredient-btn");
  const details = $$(".ingredient-detail");
  if (!btns.length) return;
  btns.forEach((btn, i) => {
    btn.addEventListener("click", () => {
      var _a;
      btns.forEach((b) => b.classList.remove("is-active"));
      details.forEach((d) => d.classList.add("is-hidden"));
      btn.classList.add("is-active");
      (_a = details[i]) == null ? void 0 : _a.classList.remove("is-hidden");
    });
  });
})();
(function initNewsletter() {
  $$(".newsletter-form").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const content = form.closest(".newsletter-section__content");
      const success = content == null ? void 0 : content.querySelector(".newsletter-success");
      if (success) {
        form.style.display = "none";
        success.classList.add("is-visible");
      }
    });
  });
})();
(function initScrollReveal() {
  const els = $$(".reveal");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-visible"));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });
  els.forEach((el) => observer.observe(el));
})();
